import React                                from 'react';
import { Observe }                          from 'rewire-core';
import { WithStyle }                        from 'rewire-ui';
import Button                               from '@material-ui/core/Button';
import { Theme }                            from '@material-ui/core/styles';
import RoutedEntityListView                 from '../ui/RoutedEntityListView';
import TimecardTestListCardView             from './TimecardTestListCardView';
import timecardTestListModel                from './TimecardTestListModel';
import { withStyles }                       from '../utility/styles';

const styles = (theme: Theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginBottom: '7px',
  },
  button: {
    flex: '1',
    minWidth: '0',
    textTransform: 'none',
    flexShrink: 0,
    marginRight: '7px',
    backgroundColor: theme.palette.warning.main,
    '&:hover': {
      backgroundColor: theme.palette.warning.light,
    },
    '&:last-child': {
      marginRight: '0px',
    },
  },
});

interface ITimecardTestListViewProps {
  classes?: any;
}

type TimecardTestListViewProps = WithStyle<ReturnType<typeof styles>, ITimecardTestListViewProps>;

class TimecardTestListView extends React.PureComponent<TimecardTestListViewProps> {
  constructor(props: TimecardTestListViewProps) {
    super(props);
  }

  handleRunSelectedTest = () => {
    timecardTestListModel.runSelectedTest();
  };

  handleRunAllTests = () => {
    timecardTestListModel.runAllTests();
  };

  renderTimecardTestListHeader = () => {
    const { classes } = this.props;

    return (
      <Observe render={() => (
        <div className={classes.header}>
          <Button disabled={!timecardTestListModel.canRunAllTests} onClick={this.handleRunAllTests} className={classes.button} variant='contained'>
            <span>Run All Tests</span>
          </Button>
          <Button disabled={!timecardTestListModel.canRunSelectedTest} onClick={this.handleRunSelectedTest} className={classes.button} variant='contained'>
            <span>Run Selected Test</span>
          </Button>
        </div>
      )} />
    );
  };

  render() {
    return (
      <RoutedEntityListView model={timecardTestListModel} ListHeader={this.renderTimecardTestListHeader} cardViewRenderer={TimecardTestListCardView} />
    );
  }
}

export default withStyles<ITimecardTestListViewProps>(styles, TimecardTestListView);
